module.exports = __webpack_public_path__ + "media/assets/img/flags/en-6bf3cf5d375d7561cb3b9bf74212ed45.png";